"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
/**
 * Reset all reward adjustments in order
 * @param event event of type OrderEvent
 * @param prevState previous order state
 */
function default_1(event, prevState = {}) {
    var _a;
    const order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    // reset order level rewards
    order.adjustments = (order.adjustments || []).filter(adj => adj.adjustmentType !== domain_1.AdjustmentType.REWARD);
    // reset item level rewards
    (_a = order.orderItems) === null || _a === void 0 ? void 0 : _a.forEach(orderItem => {
        orderItem.adjustments = (orderItem.adjustments || []).filter(adj => adj.adjustmentType !== domain_1.AdjustmentType.REWARD);
        orderItem.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(orderItem);
    });
    return {
        ...order,
        ...(0, computePrice_1.computeOrderTotals)(order),
    };
}
exports.default = default_1;
//# sourceMappingURL=resetRewards.js.map